module.exports = __webpack_public_path__ + "static/media/OurStaff.6f0acdb9.png";